/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var e = require("@lexical/react/LexicalComposerContext"),
    f = require("lexical"),
    g = require("react");

var m = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement;
var n = m ? g.useLayoutEffect : g.useEffect;
var p = {
  tag: "history-merge"
};

function q(a, c) {
  if (null !== c) if (void 0 === c) a.update(function () {
    var b = f.$getRoot();

    if (b.isEmpty()) {
      var d = f.$createParagraphNode();
      b.append(d);
      b = m ? document.activeElement : null;
      (null !== f.$getSelection() || null !== b && b === a.getRootElement()) && d.select();
    }
  }, p);else if (null !== c) switch (_typeof(c)) {
    case "string":
      var b = a.parseEditorState(c);
      a.setEditorState(b, p);
      break;

    case "object":
      a.setEditorState(c, p);
      break;

    case "function":
      a.update(function () {
        f.$getRoot().isEmpty() && c(a);
      }, p);
  }
}

exports.LexicalComposer = function (_ref) {
  var a = _ref.initialConfig,
      c = _ref.children;
  var b = g.useMemo(function () {
    var d = a.theme,
        h = a.namespace,
        r = a.editor__DEPRECATED,
        t = a.nodes,
        u = a.onError,
        v = a.editorState,
        w = e.createLexicalComposerContext(null, d);
    var k = r || null;

    if (null === k) {
      var l = f.createEditor({
        editable: a.editable,
        namespace: h,
        nodes: t,
        onError: function onError(x) {
          return u(x, l);
        },
        theme: d
      });
      q(l, v);
      k = l;
    }

    return [k, w];
  }, []);
  n(function () {
    var d = a.editable,
        _b = _slicedToArray(b, 1),
        h = _b[0];

    h.setEditable(void 0 !== d ? d : !0);
  }, []);
  return g.createElement(e.LexicalComposerContext.Provider, {
    value: b
  }, c);
};